export default __webpack_public_path__ + "static/B0122-6884a50727a81f5ded5a1b064a7d265e.png";